// extracted by mini-css-extract-plugin
module.exports = {"card":"UpdateTransactionForm_card__2Rnbg","outer":"UpdateTransactionForm_outer__1tctF","inner":"UpdateTransactionForm_inner__2-riA"};